export default Object.freeze({
  FuncionarioDEPR: 35,
  AsistenciaTecnologica: 4,
  EvaluadorAutorizadoAT: 37,
});
